export const onOpenFile = (base64Data: string, filename: string) => {
  var element = document.createElement("a");
  element.setAttribute("href", base64Data);
  element.setAttribute("download", filename);
  element.style.display = "none";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

export const onDownloadFile = (file: any) => {
  onOpenFile(
    "data:" + file.MimeType + ";base64," + file.FileData,
    file.FileName
  );
};
